<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row page__row_between">
        <div class="page__item">
          <h1 class="title">Виды занятости</h1>
        </div>
        <div class="page__item">
          <AppButtonSmAdd title="Создать" @click.native="showCreateModal" />
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row mb-20" v-if="employments.length !== 0">
        <AppTable :data="employments"
                  :headers="tableHeaders"
                  :isMenuControlsActive="roleAccessRemove"
                  @show-this-item="showUpdateModal"
                  @toggle-controls="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20" v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="В разделе еще нет ни одной записи"/>
        </div>
      </div>
    </section>

    <section class="section page__footer directory-list__footer">
      <div class="page__row">
        <!--место для пагинации-->
      </div>
    </section>

    <transition-group name="fade">
      <AppConfirmation v-if="removeConfirmation.active"
                       key="remove-confirmation"
                       text="Вы действительно хотите удалить этот вид занятости?"
                       @confirm="removeItem"
                       @reject="closeModals"
      />
      <ItemUpdateModal v-if="updateModal.active"
                       key="update-modal"
                       title="Редактировать вид занятости"
                       :item="updateModal.employment"
                       :name-validation="updateModal.validation"
                       @set-item-name="setItemUpdatedName"
                       @update-item="updateItem"
                       @close-modal="closeModals"
      />
      <ItemCreateModal v-if="createModal.active"
                       key="create-modal"
                       title="Создать вид занятости"
                       :value="createModal.newEmploymentName"
                       :name-validation="createModal.validation"
                       @set-item-name="setNewItemName"
                       @create-item="createItem"
                       @close-modal="closeModals"
      />
    </transition-group>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import AppTable from '../../../components/page/table/AppTable'
import AppConfirmation from '../../../components/page/modal/AppConfirmation'
import AppButtonSmAdd from '../../../components/page/button/AppButtonSmAdd'
import ThePagePreloader from '../../../components/page/ThePagePreloader'
import ItemUpdateModal from '../../../components/page/modal/itemUpdateModal'
import ItemCreateModal from '../../../components/page/modal/itemCreateModal'
import AppNoRecordsPlaceholder from '../../../components/page/text/AppNoRecordsPlaceholder'

export default {
  name: 'EmploymentsList',
  components: {
    AppNoRecordsPlaceholder,
    ItemCreateModal,
    ItemUpdateModal,
    ThePagePreloader,
    AppButtonSmAdd,
    AppConfirmation,
    AppTable
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null
      }
    }
  },
  computed: {
    employments () {
      const employments = this.$store.getters.employments
      const employmentsData = []
      for (let i = 0; i < employments.length; ++i) {
        employmentsData.push({
          id: employments[i].id,
          isControlsActive: employments[i].isControlsActive,
          values: [
            employments[i].name
          ]
        })
      }
      return employmentsData
    },
    isLoading () {
      return this.$store.getters.employmentListIsLoading
    },
    tableHeaders () {
      return this.$store.getters.employmentListTableHeaders
    },
    updateModal () {
      return this.$store.getters.employmentListUpdateModal
    },
    createModal () {
      return this.$store.getters.employmentListCreateModal
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContracts.actions.remove
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch('toggleEmploymentListItemControls', itemId)
    },
    showCreateModal () {
      this.$store.dispatch('showEmploymentListCreateModal')
    },
    setNewItemName (name) {
      this.$store.dispatch('setCreatedEmploymentName', name)
      this.$store.dispatch('clearEmploymentListModalValidation')
    },
    createItem () {
      this.$store.dispatch('createEmployment')
    },
    showUpdateModal (itemId) {
      this.$store.dispatch('showEmploymentListUpdateModal', itemId)
    },
    setItemUpdatedName (name) {
      this.$store.dispatch('setUpdatedEmploymentName', name)
      this.$store.dispatch('clearEmploymentListModalValidation')
    },
    updateItem () {
      this.$store.dispatch('updateEmployment')
    },
    showRemoveConfirmation (itemId) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = itemId
    },
    removeItem () {
      this.$store.dispatch('deleteEmployment', this.removeConfirmation.id)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    closeModals () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
      this.$store.dispatch('closeEmploymentListModals')
      this.$store.dispatch('clearEmploymentListModalValidation')
    }
  },
  mounted () {
    this.$store.dispatch('getEmployments')
  }
}
</script>

<style lang="scss" scoped>
.directory-list {
  &__footer {
    padding-bottom: 110px;
  }
}

.no-records {
  width: 100%;
  margin-top: 80px;
}
</style>
